/**
 * Main.js
 * @dependencies jQuery, jQuery.Cycle2, jQuery.mapify
 */


(function($, site) {


    // Create site object if it doesn't already exist
    site = site || {};


    /**
     * Function to initialize the mobile navigation
     */
    site.mobileNav = function() {

        var $nav = $('.nav');
        var $button = $('<a href="#" class="mobile-menu-button">MENU ' +
                            '<div class="burger">' +
                                '<span class="line-1"></span>' +
                                '<span class="line-2"></span>' +
                                '<span class="line-3"></span>' +
                            '</div>' +
                        '</a>');

        // if no nav found return
        if($nav.length === 0) {
            return;
        }

        // function to show/hide nav
        function toggleNav(e) {

            if(e !== undefined) {
                // this must be the button click event
                e.preventDefault();
                $button.toggleClass('-close');
            }

            // toggle the hidden class on nav list
            $nav.find('ul').toggleClass('-mobile-hidden');

        }

        // add button to DOM and attach event listener
        $button.prependTo($nav).on('click', toggleNav);

        // we're ready now hide the nav
        toggleNav();

    };


    /**
     * Function to smoothly scroll to an element
     * @param $elem [object] jQuery object representing the element to scroll to
     * @param speed [int] The speed to perform the scroll, defaults to 800
     */
    function smoothScroll($elem, speed) {

        speed = speed || 800;

        // if $elem is not a jQuery obj or is empty then return
        if(!($elem instanceof $) || $elem.length !== 1) {
            return;
        }

        // animate a scroll to the element
        $('html, body').animate({
            scrollTop: $elem.offset().top
        }, speed);

    }


    /**
     * Function to attach event handler to smooth scroll links
     * links should have `js-smooth-scroll` and link to an element with an ID
     */
    site.smoothScrollLinks = function() {

        var $links = $('.js-smooth-scroll');

        // if no links return
        if($links.length === 0) {
            return;
        }

        // function to do a scroll
        // @param $link [obj] jQuery object of link element
        // @param hash [string] the targets selector
        function doScroll($link, hash) {

            var $target = $('#'+hash);

            if($target.length !== 0) {

                $link.on('click', function(e) {
                    e.preventDefault();
                    // trigger the smoothScroll
                    smoothScroll( $target );
                });

            }

        }

        // function to prepend underscore to hash
        // @param $link [obj] jQuery object of link element
        // @param hash [string] the targets selector
        function prependToHash($link, hash) {

            if($link.length === 0) {
                return;
            }

            // prepend underscore to the href
            $link.attr('href', '#_'+hash);

        }

        // loop through the links
        $links.each(function() {

            var $self = $(this);
            var href = $self.attr('href');
            var path = href.split('#')[0];
            var hash = href.split('#')[1];
            var thisPath = window.location.pathname;

            if(
                href.slice(0,1) === '#' ||
                href.split('#')[0].slice((-thisPath.length)) === thisPath
            ) {
                // we have an inpage anchor, just do the scroll
                doScroll($self, hash);
                return;
            }

            if(href.indexOf(window.location.host) !== -1) {
                // different page but same domain
                // prepend underscore to hash so that we can
                // trigger a smooth scroll on the new page load
                prependToHash($self, hash);
            }

        });

    };


    /**
     * Function to trigger smooth scroll onload, anchors should begin
     * with an underscore to trigger the smooth scroll
     */
    site.autoSmoothScroll = function() {

        var target = window.location.hash;

        // if no target or target does not start with underscore then return
        if(!target || target.slice(1,2) !== '_') {
            return;
        }

        // perform smooth scroll to the target
        smoothScroll( $('#' + target.slice(2)) );

    };


    /**
     * Function to initialize the slider(s)
     * The site has 2 sliders, one for the big background image,
     * the other for the call to action box. They will not scroll automatically
     * and should run in unison.
     */
    site.slider = function() {

        var $images = $('.js-slider-images');
        var $ctas = $('.js-slider-ctas');
        var $prev = $('<a href="#" class="slider-controls button icon-font -prev"></a>');
        var $next = $('<a href="#" class="slider-controls button icon-font -next"></a>');

        // slider configuration

        var commonConfig = {
            swipe: true,
            timeout: 0
        };

        var imagesConfig = $.extend({
            speed: 1000,
            slides: '.slide'
        }, commonConfig);

        var ctaConfig = $.extend({
            speed: 500,
            slides: '.cta-slide'
        }, commonConfig);

        // if no sliders or no cycle plugin don't bother
        if(
            typeof $().cycle !== 'function' ||
            $images.length === 0 ||
            $ctas.length === 0 ||
            ($images.find('.slide').length < 2 && $ctas.find('.cta-slide').length < 2)
        ) {
            return;
        }

        // Initialise cycle
        $images.cycle(imagesConfig);
        $ctas.cycle(ctaConfig);

        // Append slider controls
        $ctas.append( $prev.add($next) );

        // Attach event listeners to controls

        $prev.on('click', function(e) {
            e.preventDefault();
            $images.cycle('prev');
            setTimeout(function() {
                $ctas.cycle('prev');
            }, 700);
        });

        $next.on('click', function(e) {
            e.preventDefault();
            $images.cycle('next');
            setTimeout(function() {
                $ctas.cycle('next');
            }, 700);
        });

    };


    /**
     * Function to initialize a Google map, uses jQuery.mapify
     */
    site.map = function() {

        var $map = $('.js-map');

        // our maps settings
        var config = {
            zoom: 16,
            key: 'AIzaSyABvVmkJlrC0WMQWMMpLQ5dtOeTMf7h11Q',
            points: [
                {
                    lat: 53.950867,
                    lng: -1.085778,
                    marker: true,
                    title: 'Meltons Restaurant',
                    infoWindow: '<p>7 Scarcroft Road<br />'+
                                'York<br />'+
                                'YO23 1ND</p>'
                }
            ]
        };

        // if no map or mapify plugin, return
        if($map.length === 0 || typeof $().mapify !== 'function') {
            return;
        }

        // initialize map
        $map.mapify(config);


    };

    /**
     * Function to swap the content of alternative content block rows
     * because we use display: table-cell we can't use floats to arrange content
     */
    site.altRows = function() {

        // get rows defined as `alt`
        var $rows = $('.content-block.alt');

        // no rows? forget it...
        // window smaller than 960, no need...
        if($rows.length === 0 || $(window).width() < 960) {
            return;
        }

        // function to swap the divs
        function divSwapper() {

            $rows.each(function() {

                var $self = $(this);

                var $firstDiv = $self.find('> div:first-child');
                var $lastDiv = $self.find('> div:last-child');

                // move the first div to the end
                $firstDiv.insertAfter($lastDiv);

            });

        }

        // I guess we could add a window size listener, and swap the elements back
        // if required, but why add the overhead for very little benefit in a situation
        // which will be rare anyway... lets just do this once...

        divSwapper();

        // add the proper modifier class to trigger neccessary CSS changes
        $rows.addClass('-alt');

    };


    // what should we do on DOM ready?
    $(document).ready(function() {

        // run some of the functions we just created...
        site.mobileNav();
        site.smoothScrollLinks();
        site.autoSmoothScroll();
        site.slider();
        site.map();
        site.altRows();

    });


    // attach site object to window so that we can see it in the console,
    // or use it in another file
    window.site = site;


})(jQuery);
